export default __webpack_public_path__ + "static/media/no-messages.ca44d631.png";